import styled from 'styled-components';
import { ReactComponent as Heart } from 'App/assets/img/heart.svg';

type StatusIconProps = {
	color: string;
	cursor: string;
};

type TooltipProps = {
	position: { x: number; y: number };
	visible: boolean;
	correction: number;
};

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	position: relative;
`;

export const Tooltip = styled.div<TooltipProps>`
	position: fixed;
	width: fit-content;
	background-color: #414d5c;
	opacity: 0.9;
	color: #fff;
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	top: ${({ position }) => position.y - 30}px;
	left: ${({ position, correction }) => position.x - 68 - correction}px;
	z-index: 999;
	visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};

	&::before {
		content: '';
		position: absolute;
		width: 0;
		height: 0;
		border-left: 6px solid transparent;
		border-right: 6px solid transparent;
		border-bottom: 6px solid #414d5c;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		transform: rotate(180deg);
	}
`;

export const StatusIcon = styled(Heart)<StatusIconProps>`
	width: 18px;
	height: 18px;
	cursor: ${({ cursor }) => cursor};

	.tooltip {
		visibility: visible;
	}

	& > path {
		fill: ${({ color }) => color};
	}
`;

export const EmptyExams = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	gap: 8px;
`;
